import BasePainterTool from './BasePainterTool';
import TOOL_NAMES from './constants/toolNames';
import { refreshViewport } from './commands';

export default class BBoxTool extends BasePainterTool {
  constructor(props = {}) {
    const defaultProps = { name: TOOL_NAMES.BOUNDING_BOX_TOOL };
    const initialProps = Object.assign(defaultProps, props);
    super(initialProps, 'bbox');
  }

  disabledCallback(element) {
    const painters = this._getPainters(element);
    for (const p of painters) {
      if (p?._mode === 'bbox') p.clear();
    }
    refreshViewport();
  }

  _drawingUpCallback(evt, shouldUpdate = true) {
    const eventData = evt.detail;
    const element = eventData.element;

    this._isDrawing = false;
    delete this._imageId;
    delete this._cursorCanvasPosition;

    if (shouldUpdate) {
      if (eventData.type !== 'cornerstonetoolsmouseup') return;
      const painter = this._getPainter(element);
      painter.commit(evt).then(() => refreshViewport());
    }
  }
}
